<script lang="ts" setup>
import { Employee } from '../../components/EmployeeSingle.vue'

const props = defineProps<{
  person: Employee
  hideImages?: boolean
}>()

const validateEmail = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
}

const linkUrl = computed(() => props.person.link?.url || '')
const linkText = computed(() => props.person.link?.text || '')

// Extract email if it's a mailto link
const email = computed(() => {
  if (linkUrl.value.startsWith('mailto:')) {
    return linkUrl.value.replace('mailto:', '')
  }
  return null
})

// Check if the URL is an email (either mailto: or plain email format)
const isEmail = computed(() => {
  if (email.value) return true
  // Also check if the URL itself is a plain email address
  return linkUrl.value ? validateEmail(linkUrl.value) : false
})

// For handling plain email addresses without mailto:
const emailAddress = computed(() => {
  if (email.value) return email.value
  if (isEmail.value) return linkUrl.value
  return null
})

const controller = useModal()
</script>

<template>
  <PersonBase :hide-image="hideImages" :person="person">
    <!-- Handle email links -->
    <template v-if="isEmail">
      <button v-if="emailAddress" class="link-default text-small" @click="controller.open">
        {{ linkText }}
      </button>
      <ModalContactForm v-if="emailAddress" :controller="controller">
        <EmailContactForm :email-to="emailAddress" :recipient-name="person.name" />
      </ModalContactForm>
    </template>
    <!-- Handle regular links (internal and external) -->
    <NuxtLink
      v-else-if="linkUrl"
      :to="linkUrl"
      :target="person.link?.target || '_self'"
      class="link-default text-small"
    >
      {{ linkText }}
    </NuxtLink>
  </PersonBase>
</template>
